var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{class:['pageLoader', { 'is-visible': _vm.visible }],attrs:{"value":_vm.visible,"color":"white","opacity":"1"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }